import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const userModelGroupMappingService = {
  // GET - Fetch mappings by user ID (or company ID)
  getUserModelGroupMappingsByUser: async (data) => {
    try {
      // Try with userId, if fails try with companyId
      const payload = data.userId ? { userId: data.userId } : { companyId: data.companyId };
      
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_USER_MODEL_GROUP_MAPPINGS_BY_USER,
        method: 'POST',
        data: payload,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get user model group mappings by user error:', error);
      throw error;
    }
  },

  // GET - Fetch mappings by model group ID
  getUserModelGroupMappingsByModelGroupId: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_USER_MODEL_GROUP_MAPPINGS_BY_MODEL_GROUP_ID,
        method: 'POST',
        data: { modelGroupId: data.modelGroupId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get user model group mappings by model group ID error:', error);
      throw error;
    }
  },


  // CREATE
  createUserModelGroupMapping: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.CREATE_USER_MODEL_GROUP_MAPPING,
        method: 'POST',
        data: {
          companyId:  data.companyId,
          modelGroupId: data.modelGroupId,
          userIds:    data.userIds,
          createdBy:  data.createdBy,
        },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Create user model group mapping error:', error.response?.data ?? error);
      throw error;
    }
  },

  // UPDATE
  updateUserModelGroupMapping: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_USER_MODEL_GROUP_MAPPING,
        method: 'POST',
        data: {
          companyId:  data.companyId,
          modelGroupId: data.modelGroupId,
          userIds:    data.userIds,
          isActive:   data.isActive,
          updatedBy:  data.updatedBy,
        },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update user model group mapping error:', error.response?.data ?? error);
      throw error;
    }
  },

  // DELETE
  deleteUserModelGroupMapping: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_USER_MODEL_GROUP_MAPPING,
        method: 'POST',
        data: {
          companyId:  data.companyId,
          modelGroupId: data.modelGroupId,
          userIds:    data.userIds,
          updatedBy:  data.updatedBy,
        },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete user model group mapping error:', error.response?.data ?? error);
      throw error;
    }
  },
};